import { useEffect } from "react";

import { env } from "@/env";

const inMaintenanceMode = env.VITE_MAINTENANCE_MODE === "true";

export const useMaintenanceMode = () => {
  useEffect(() => {
    if (inMaintenanceMode) {
      window.location.href = env.VITE_MAINTENANCE_REDIRECT_URL;
    }
  }, []);
};
